"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
import { Menu } from "lucide-react";
import { useMobileNav } from "@/contexts/MobileNavContext";

/**
 * MobileMenuButton - Logo + Hamburger for mobile navigation
 *
 * Use this in Server Components that need the mobile nav controls.
 * Only visible on mobile (md:hidden).
 *
 * - Logo: Tappable, navigates to /app (home)
 * - Hamburger: Opens mobile nav drawer
 */
export default function MobileMenuButton() {
  const $ = _c(6);
  const {
    open
  } = useMobileNav();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Menu className="h-5 w-5 text-gray-700" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== open) {
    t1 = <button type="button" onClick={open} className="flex h-11 w-11 items-center justify-center rounded-xl transition-colors active:bg-gray-200" aria-label="Open navigation menu">{t0}</button>;
    $[1] = open;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/app" className="flex h-11 w-11 items-center justify-center rounded-xl transition-colors active:bg-gray-200" aria-label="Go to home"><Image src="/img/favicons/favicon.svg" alt="Outfame" width={28} height={28} className="h-7 w-7" /></Link>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="flex items-center md:hidden">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}